import lodashKeyBy from 'lodash.keyby';

function ProfileMatcher (fromProfiles, toProfiles) {
    const fromProfilesMap = lodashKeyBy(fromProfiles, 'id');
    const toProfilesMap = lodashKeyBy(toProfiles, 'xid');

    return {
        match (fromProfileId) {
            const fromProfile = fromProfilesMap[fromProfileId];
            if (fromProfile) {
                return toProfilesMap[fromProfile.xid] || null;
            }
            return null;
        }
    };
}

export default ProfileMatcher;
